import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const ACCESS_KEY = "emaia_access";

export const getCustomerToken = () => {
  try {
    const v = JSON.parse(localStorage.getItem(ACCESS_KEY) || "null");
    if (!v || v.exp < Date.now()) return null;
    return v.token;
  } catch {
    return null;
  }
};
export const setCustomerToken = (token) =>
  localStorage.setItem(ACCESS_KEY, JSON.stringify({ token, exp: Date.now() + 90 * 24 * 3600 * 1000 }));
export const clearCustomerToken = () => localStorage.removeItem(ACCESS_KEY);

api.interceptors.request.use((cfg) => {
  const t = getCustomerToken();
  if (t && !cfg.url.startsWith("/admin")) cfg.headers["X-Customer-Token"] = t;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const isAdmin = cfg && (cfg.url.startsWith("/admin") || cfg.url === "/auth/me");
    if (err.response?.status === 401 && isAdmin && !cfg._retry) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export const fetcher = (url) => api.get(url).then((r) => r.data);

export const imgUrl = (p) => (!p ? "" : p.startsWith("http") || p.startsWith("/") ? p : `${API}/files/${p}`);

export const brl = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }).replace(/\u00a0/g, " ");

export const errMsg = (e, fallback = "Algo deu errado. Tente novamente.") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return d.msg || fallback;
};

export const GENDERS = { masculino: "Masculino", feminino: "Feminino", unissex: "Unissex" };

export const formatDate = (iso, withTime = false) =>
  iso ? new Date(iso).toLocaleString("pt-BR", withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "short" }) : "—";

export const phoneMask = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
